export enum ApiRoutes {
  // Auth Public Key
  AUTH_SIGN_IN_PK = '/pub/users/auth/sign-in/public-key',
  AUTH_SIGN_UP_PK = '/pub/users/auth/sign-up/public-key',
  AUTH_VERIFY_PK = '/pub/users/auth/verify/public-key',
  AUTH_LINK_PK = '/ext/users/auth/link/public-key',
  AUTH_VERIFY_LINK_PK = '/ext/users/auth/link/verify/public-key',
  AUTH_LOGOUT = '/ext/users/auth/logout',

  // Auth Email
  AUTH_SIGN_IN_EMAIL = '/pub/users/auth/sign-in/email',
  AUTH_SIGN_UP_EMAIL = '/pub/users/auth/sign-up/email',
  AUTH_VERIFY_EMAIL = '/pub/users/auth/verify/email',

  // Auth Phone
  AUTH_SIGN_IN_PHONE = '/pub/users/auth/sign-in/phone',
  AUTH_SIGN_UP_PHONE = '/pub/users/auth/sign-up/phone',
  AUTH_VERIFY_PHONE = '/pub/users/auth/verify/phone',

  // Auth 2FA
  AUTH_INIT_TOTP = '/ext/users/auth/mfa/register-totp',
  AUTH_CONFIRM_TOTP = '/ext/users/auth/mfa/confirm-totp',
  AUTH_VERIFY_TOTP = '/pub/users/auth/mfa/verify-totp',
  AUTH_DELETE_TOTP = '/pub/users/auth/disable-mfa?userId={userId}&type={type}',

  // Auth Passkey
  AUTH_LOGIN_PASSKEY_REGISTER_START = '/ext/users/auth/mfa/register-passkey-start',
  AUTH_LOGIN_PASSKEY_REGISTER_FINISH = '/ext/users/auth/mfa/register-passkey-finish',
  AUTH_LOGIN_PASSKEY_START = '/pub/users/auth/mfa/verify-passkey-start',
  AUTH_LOGIN_PASSKEY_FINISH = '/pub/users/auth/mfa/verify-passkey-finish',

  // Refresh Token
  AUTH_REFRESH_TOKEN = '/pub/users/auth/refresh-token',

  // Profile
  GET_USER_WALLET = '/ext/wallet',
  GET_USER_PROFILE = '/ext/users/auth/profile',

  // Cards
  GET_USER_CARDS = '/ext/cards',

  REFERRAL_PROGRAM_AMOUNT = '/ext/cards/referralProgram/amount',
  REFERRAL_PROGRAM_CLAIM = '/ext/cards/referralProgram/claim',
  REFERRAL_PROGRAM_APPLY = '/ext/users/referral-program/applyReferralCode',

  CARD_ISSUE = '/ext/cards/issue',
  CARD_FREEZE = '/ext/cards/{id}/freeze',
  CARD_UNFREEZE = '/ext/cards/{id}/unfreeze',
  BLOCK_CARD = '/ext/cards/{id}/terminate',
  CARDS_CREATE_INVOICE = '/ext/cards/invoices',
  CARDS_CHECK_INVOICE_STATUS = '/ext/billing/invoices/{id}',
  CARDS_BILLING_INIT = '/ext/billing/invoices/{id}/init',
  CARDS_CHANGE_ACCOUNT = '/ext/cards/{id}/changeAccount',

  // Wallet
  DELEGATE_CARD = '/ext/tx/delegate/init',
  DELEGATE_CARD_CONFIRM = '/ext/tx/confirmation',
  DELEGATE_REVOKE = '/ext/tx/delegate/revoke',
  DELEGATE_BALANCES = '/ext/wallet/delegate/balances',
  DELEGATE_SUGGESTIONS = '/ext/wallet/delegate/suggestions',

  // Transactions
  GET_TRANSACTIONS_LIST = '/ext/users/transactions/v2/history',
  GET_TRANSACTION_DETAILS = '/ext/users/transactions/v2/history/{id}',

  // KYC
  KYC_CAN_ISSUE = '/ext/cards/can-issue-raw',
  KYC_TOKEN= '/ext/kyc/token',

  SET_MAIN_WALLET = '/ext/wallet/{pk}/main',
  SET_WALLET_NAME = '/ext/wallet/{pk}/rename',

  SET_CARD_NAME = '/ext/cards/{id}/rename',
  SET_CARD_PIN = '/ext/cards/rain/{id}/setPin',
  CARD_PIN_ENCRYPTION_KEY = '/ext/cards/rain/pubKey',
  CARD_RAIN_DETAILS_ENCRYPTED = '/ext/cards/rain/{id}/details/encrypted',

  ACCEPT_KYC_RAIN_TERMS = '/ext/kyc/rain/terms',

  LINK_EMAIL = '/ext/users/auth/link/email',
  LINK_EMAIL_VERIFY = '/ext/users/auth/link/verify/email',

  LINK_PHONE = '/ext/users/auth/link/phone',
  LINK_PHONE_VERIFY = '/ext/users/auth/link/verify/phone',

  PUB_EMAIL_VERIFY_START = '/pub/users/auth/verify/email-start',
  PUB_EMAIL_VERIFY_FINISH = '/pub/users/auth/verify/email-finish',

  PUB_PASSKEY_START = '/pub/users/auth/mfa/register-passkey-start',
  PUB_PASSKEY_FINISH = '/pub/users/auth/mfa/register-passkey-finish',

  PUB_TOTP_START = '/pub/users/auth/mfa/register-totp-start',
  PUB_TOTP_FINISH = '/pub/users/auth/mfa/register-totp-confirm',

  NOTIFICATIONS = '/ext/notifications/list',

  TARIFFS = '/ext/tariff/instance/current',
  PAY_TARIFF = '/ext/tariff/pay',
}

export enum AppRoutes {
  AUTH_SIGNIN = '/auth/signin',

  TRANSACTIONS_PAGE = '/transactions',
  EVENTS_PAGE = '/events/{pk}',
  TRANSACTION_DETAILS_PAGE = '/transactions/{id}',
  TRANSACTION_FEES_RATES_PAGE = '/transactions/{id}/fees-and-rates',

  CARDS_PAGE = '/cards',
  CARDS_RENAME_PAGE = '/cards/{id}/rename',
  CARDS_SET_PIN_PAGE = '/cards/{id}/pin',
  CARDS_HISTORY_PAGE = '/cards/{id}/history',
  CARDS_SUBSCRIPTION_PAGE = '/cards/subscription',
  CARDS_TOKEN_PAGE = '/cards/token',
  CARDS_NOT_ALLOED = '/cards/notallowed',
  CARD_READY_PAGE = '/cards/ready',
  CARDS_RAIN_RULES = '/cards/rules',

  TARIFF_LIST = '/tariff/list',
  TARIFF_PAYMENT = '/tariff/payment',

  PROFILE_PAGE = '/profile',
  PROFILE_DETAILS_PAGE = '/profile/details',
  ASSET_DETAILS_PAGE = '/assets/{id}',
  INDEX_PAGE = '/',

  SECURITY_PAGE = '/profile/security',
  TOTP_PAGE = '/profile/security/totp',
  TOTP_CODE_PAGE = '/profile/security/totp/code',
  TOTP_SUCCESS_PAGE = '/profile/security/totp/success',
  TOTP_DISABLE_PAGE = '/profile/security/totp/disable',
  PASSKEY_PAGE = '/profile/security/passkey',
  PASSKEY_SET_PAGE = '/profile/security/passkey/success',

  TRANSACTION_CONFIRM = '/transactions/confirm/{type}',

  KYC_V2_PAGE = '/kyc',

  KYC_ADD_PHONE_CODE = '/kyc/phone/code',
  KYC_SUCCESS_PAGE = '/kyc/success',

  WALLETS_PAGE = '/wallets',
  WALLETS_RENAME_PAGE = '/wallets/{address}/rename',
  WALLETS_DETAILS_PAGE = '/wallets/{address}/details',
  WALLET_ADD_PAGE = '/wallets/add',
  CONNECT_WALLET_ONLY_PAGE = '/connect-wallet-only',

  PUB_EMAIL = '/pub/email',
  PUB_EMAIL_CODE = '/pub/email/code',

  PUB_MFA = '/pub/mfa',
  PUB_TOTP = '/pub/totp',
  PUB_TOTP_CODE = '/pub/totp/code',

  PUB_DIRECT_LOGIN = '/pub/direct',

  NOTIFICATIONS = '/notifications',

  REFERRAL = '/referral',
}
